import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: "timer",
    style: _normalizeStyle({ color: _ctx.timeRemaining <= 10 ? '#ff4444' : '#000000' })
  }, " ⏱️ " + _toDisplayString(_ctx.formatTime(_ctx.timeRemaining)), 5 /* TEXT, STYLE */))
}